import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'znizki/';

export default {

    getZnizki() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getZnizkiDanejTrasy(idTr) {
        return axios({
            method: 'get',
            url: URL + 'trasa/'+idTr,
        });
    },

    addZnizka(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editZnizka(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteZnizka(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

    getWszytskieZnizkiMiesieczne(data) {
        return axios({
            method: 'post',
            url: URL+'miesieczne',
            data: JSON.stringify(data),
        })
    },

    getWszytskieZnizkiJednorazowe(data) {
        return axios({
            method: 'post',
            url: URL+'jednorazowe',
            data: JSON.stringify(data),
        })
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/znizki/ZnizkiService.js